export default __webpack_public_path__ + "static/cards-en@2x-455330283211233b2a1dd1edfe3d7b6e.png";